export default "__VITE_ASSET__BZzvmsA0__"